export enum OwnerVIPCategory {
	GOLD = 1,
	SILVER = 2,
	ROYAL = 3,
	DIAMOND = 4,
	PLATINUM = 5,
}

export enum OwnerVIPRequestStatus {
	ALL = 0,
	PENDING = 1,
	CANCEL = 2,
	COMPLETED = 3,
	PICKED = 4,
}

export interface OwnerVIPRequest {
	OwnerParticipantId: number;
	RequestDescriptionEn: string;
	RequestDescriptionAR: string;
	RequestSource: number;
	Documents?: OwnerVIPDocument[];
}

export interface OwnerVIPDocument {
	DocumentName: string;
	DocumentPath: string;
}

export interface VIPRequest {
	OwnerRequestId: number;
	RequestStatusId: number;
	RequestDescriptionEn: string;
	RequestDescriptionAr: string;
	RequestStatusNameEn: string;
	RequestStatusNameAr: string;
	ManagerNameAr: string;
	ManagerNameEn: string;
	Email: string;
	Mobile: string;
	RequestDate: string;
	Documents?: OwnerVIPDocument[];
}
